// common
export const getErrMsg = state => state.getIn(['topBar', 'errMsg']);
export const getIsLoading = state => state.getIn(['topBar', 'isLoading']);
// notification
export const getNotification = state => state.getIn(['topBar', 'notificationList']);
export const getHistory = state => state.getIn(['topBar', 'historyList']);
export const getHistoryCount = state => state.getIn(['topBar', 'historyCount']);
export const getShowRWDNavbar = state => state.getIn(['topBar', 'showRWDNavbar']);
export const getLoginCheckNotification = state => state.getIn(['login', 'loginCheckNotification']);
